import Todos from './todos.vue';
import Over from './over.vue';

export const routes = [
    { path: '', component: Todos },
    { path: '/over', component: Over },
    { path: '*', component: { template: '<div class="container"><h1>Page Not Found!</h1></div>' } }
];



// WEBPACK FOOTER //
// ./src/routes.js